import { Request } from '@/infrastructure/network/Zipcloud/schema/models'
import { Zipcloud } from '@/infrastructure/network/Zipcloud/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

export class FetchSearch implements APIRequest<Zipcloud.Search.FetchSearchResponse> {
  response: Zipcloud.Search.FetchSearchResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Request
  constructor(query?: Request) {
    this.params = query
    this.path = `/search`
  }
}
